import gsap from "gsap";
import { CustomEase } from "gsap/all";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

const ease = CustomEase.create("custom", "M0,0 C0.6,0.2 0.204,0.776 1,1");

export const sectionFadeInUp = (parent, section) => {
  const sectionFadeInUp = gsap
    .timeline({
      defaults: {
        duration: 1,
        ease: ease,
      },
    })
    .fromTo(
      section,
      {
        opacity: 0,
        y: -50,
      },
      {
        opacity: 1,
        y: 0,
        delay: section.dataset.delay ? section.dataset.delay : 0,
      },
      "sectionFadeInUp"
    );

  const sectionFadeInUp_scroller = ScrollTrigger.create({
    trigger: parent,
    start: "top 80%",
    endTrigger: document.body,
    end: "bottom bottom",
    // markers: true,
    animation: sectionFadeInUp,
  });
};

export const parallax = (value) => {
  gsap.to(value, {
    scrollTrigger: {
      scrub: 5,
    },
    yPercent: (i, target) => target.dataset.speed,
    // y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
    ease: "none",
  });
};
